<script setup>
import Layout from '../../Components/Shared/Layout.vue'
import { Link } from '@inertiajs/inertia-vue3'
import usePriceFormat from '../../Services/usePriceFormat'
import FarmCard  from '../../Components/Portfolio/FarmCard.vue'
import TreesCollection from '../../Components/Portfolio/TreesCollection.vue';
import ModalComponent from '../../Components/Shared/ModalComponent.vue';
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue';
import TreeForm from '../../Components/Forms/TreeForm.vue';
import Map from '../../Components/Map/Map.vue'
import HarvestOfferPanel from '../../Components/Portfolio/HarvestOfferPanel.vue'
import { computed, ref, watch } from "vue";
const props = defineProps(["harvest", "trees","area","fruits"])
const modal = ref(false);
const treeItems = ref([...props.trees]);
const harvestSize = ref(Number(props.harvest.size));
const trees_locations = computed(() => treeItems.value.map(item=>[item.lon,item.lat]))
const area_locations = props.area.map(item=>[item.lon,item.lat])
const all_areas = [area_locations]
const initTree = {
    name: "Arbol",
    lon:  "",
    lat: "",
    bday: new Date().toISOString().slice(0, 10),
    fruit_id: ""
};
const treeToCreate = ref(initTree);
const createTree = ()=>{
    treeToCreate.value = initTree;
    modal.value = true;
}
const resetModal = () => {
    modal.value = false;
};
const treeUpdated = tree => {
    const index = treeItems.value.findIndex(item => item.id === tree.id);
    if (index !== -1) {
        treeItems.value.splice(index, 1, tree);
    }
};
const treeDeleted = result => {
    treeItems.value = treeItems.value.filter(item => item.id !== result.treeId);
    harvestSize.value = Number(result.harvestSize);
};
watch(() => props.trees, trees => {
    treeItems.value = [...trees];
    harvestSize.value = Number(props.harvest.size);
}, { deep: true });

</script>
<template lang="">
    <layout>
        <div class="container pt-5 mx-auto">
            <div class="md:flex">
                <div class="md:w-3/4 p-10">
                    <div>
                        <ButtonComponent 
                            content="Atrás" 
                            :icon="'arrow_back_ios'"
                            :link="'/portfolio'"
                            type="2"
                        />       
                    </div>

                    <div class="md:flex w-full justify-between items-center">

                    <div class="flex items-center">
                        <img
                            class="hidden object-cover w-12 h-12 m-5 bg-white border-2 rounded-full border-enriqueto_green md:block"
                            :src="harvest.fruit.image"
                            alt=""
                        />
                        <h2 class="px-4 text-xl font-bold text-enriqueto_green">
                            {{harvest.name}}<span v-if="!harvest.has_trees"> / {{harvest.fruit.name}}</span>
                            <br>
                            <span v-if="!harvest.has_trees" class="text-2xl">{{usePriceFormat(harvest.fruit.price)}}</span>
                            <span v-else class="text-base">Árboles individuales</span>
                        </h2>
                    </div>
                    <div>
                            <p>{{harvest.has_trees ? 'Árboles' : 'Área'}}</p>
                            <h4 class="px-4 text-xl font-bold text-enriqueto_green">
                                {{harvestSize}} {{harvest.has_trees ? '' : (harvest.area_unit === 'ha' ? 'ha' : 'm²')}}
                            </h4>
                    </div>
                    <!-- <div>
                            <p>Cosechas Anuales</p>
                    </div>
                    <div>
                            <p>Cantidad x Cosecha</p>
                    </div>
                    <div>
                            <p>Cantidad Total</p>
                    </div>
                    <div>
                            <p>Valor Total Anual</p>
                    </div> -->
                    </div>
                </div>
                <div class="md:w-1/4 pt-10">
                    <FarmCard :item="harvest.farm" />
                </div>
            </div>
            <HarvestOfferPanel :harvest="harvest" :user-email="$page.props.user.email" />
            <div class="pt-5">
                <Map 
                :center="[harvest.lon,harvest.lat]" 
                :locations="trees_locations"
                locations_icon="crops@2x.png"
                :locations_area="all_areas"
                :area="true"
                :harvest="true"
                :id="'mapaHarvest'"
                ></Map>
            
            </div>
            <ButtonComponent 
                content="Añadir árbol" 
                :icon="'add'"
                :link="null"
                type="0"
                @click="createTree" 
                />
            <TreesCollection
                :items="treeItems"
                @updated="treeUpdated"
                @deleted="treeDeleted"
            />
        </div>

        <ModalComponent
            title="Crear Item"
            v-model="modal"
            v-if="modal"
        >
            <TreeForm @added="resetModal" :tree="treeToCreate" :fruits="fruits" :farm="harvest.farm" :harvest="harvest" :area="area_locations" />
        </ModalComponent>
    </layout>
</template>
<style lang="">
    
</style>
